module.exports = __webpack_public_path__ + "static/media/D_9.a328cbe8.png";